/* Inline sample datasets for the 10 Soil Science analyses. Pure JS strings. */

export const SOIL_INLINE_SAMPLES = {
  'soil-physical': `Plot_or_Location,Depth_cm,Rep,Bulk_density_g_cc,Particle_density_g_cc,Sand_percent,Silt_percent,Clay_percent,Field_capacity_percent,Permanent_wilting_point_percent,Hydraulic_conductivity_cm_hr,Aggregate_stability_percent
Forest,0-15,1,1.25,2.55,35,40,25,28,14,3.5,82
Forest,0-15,2,1.27,2.56,34,41,25,28.5,14.2,3.55,83
Forest,0-15,3,1.26,2.55,35,40,25,28.2,14.1,3.52,82.5
Forest,15-30,1,1.35,2.60,38,38,24,26,13,2.8,78
Forest,15-30,2,1.37,2.61,37,39,24,26.5,13.2,2.85,79
Forest,15-30,3,1.36,2.60,38,38,24,26.2,13.1,2.82,78.5
Cropland,0-15,1,1.42,2.55,48,32,20,22,11,2.5,55
Cropland,0-15,2,1.44,2.56,47,33,20,22.5,11.2,2.55,56
Cropland,0-15,3,1.43,2.55,48,32,20,22.2,11.1,2.52,55.5
Cropland,15-30,1,1.50,2.60,50,30,20,20,10,2.0,52
Cropland,15-30,2,1.52,2.61,49,31,20,20.5,10.2,2.05,53
Cropland,15-30,3,1.51,2.60,50,30,20,20.2,10.1,2.02,52.5
Horticulture,0-15,1,1.32,2.56,42,35,23,25,12.5,3.0,70
Horticulture,0-15,2,1.34,2.57,41,36,23,25.5,12.7,3.05,71
Horticulture,0-15,3,1.33,2.56,42,35,23,25.2,12.6,3.02,70.5
Grassland,0-15,1,1.30,2.55,40,37,23,26,13,3.2,75
Grassland,0-15,2,1.32,2.56,39,38,23,26.5,13.2,3.25,76
Grassland,0-15,3,1.31,2.55,40,37,23,26.2,13.1,3.22,75.5
Wasteland,0-15,1,1.55,2.60,55,28,17,18,9,1.8,45
Wasteland,0-15,2,1.57,2.61,54,29,17,18.5,9.2,1.85,46
Wasteland,0-15,3,1.56,2.60,55,28,17,18.2,9.1,1.82,45.5`,

  'soil-chemical': `Plot_or_Treatment,Depth_cm,Rep,pH_water,pH_KCl,EC_dS_m,Organic_carbon_percent,Total_nitrogen_percent,Available_N_kg_ha,Available_P_kg_ha,Available_K_kg_ha,Available_S_kg_ha,Available_Zn_ppm,Available_Fe_ppm,Available_Mn_ppm,Available_Cu_ppm,Available_B_ppm,CEC_cmol_kg,Base_saturation_percent
T1_Control,0-15,1,7.8,7.2,0.25,0.42,0.045,220,8,95,8,0.45,3.8,1.5,0.15,0.35,14,72
T1_Control,0-15,2,7.82,7.22,0.26,0.43,0.046,222,8.2,96,8.2,0.46,3.85,1.52,0.152,0.36,14.1,72.5
T1_Control,0-15,3,7.81,7.21,0.255,0.425,0.0455,221,8.1,95.5,8.1,0.455,3.82,1.51,0.151,0.355,14.05,72.2
T2_NPK,0-15,1,7.5,6.9,0.35,0.55,0.058,320,18,165,18,0.85,5.2,2.8,0.25,0.52,16,78
T2_NPK,0-15,2,7.52,6.92,0.36,0.56,0.059,322,18.2,166,18.2,0.86,5.25,2.82,0.252,0.53,16.1,78.5
T2_NPK,0-15,3,7.51,6.91,0.355,0.555,0.0585,321,18.1,165.5,18.1,0.855,5.22,2.81,0.251,0.525,16.05,78.2
T3_NPK_FYM,0-15,1,7.2,6.6,0.42,0.82,0.085,420,28,210,25,1.25,6.8,3.8,0.38,0.72,18,82
T3_NPK_FYM,0-15,2,7.22,6.62,0.43,0.83,0.086,422,28.2,212,25.2,1.26,6.85,3.82,0.382,0.73,18.1,82.5
T3_NPK_FYM,0-15,3,7.21,6.61,0.425,0.825,0.0855,421,28.1,211,25.1,1.255,6.82,3.81,0.381,0.725,18.05,82.2
T4_Vermicompost,0-15,1,7.0,6.4,0.38,0.95,0.098,385,25,195,22,1.15,6.5,3.5,0.35,0.68,17.5,80
T4_Vermicompost,0-15,2,7.02,6.42,0.39,0.96,0.099,387,25.2,196,22.2,1.16,6.55,3.52,0.352,0.69,17.6,80.5
T4_Vermicompost,0-15,3,7.01,6.41,0.385,0.955,0.0985,386,25.1,195.5,22.1,1.155,6.52,3.51,0.351,0.685,17.55,80.2
T5_Biofert,0-15,1,7.4,6.8,0.32,0.68,0.072,350,22,180,20,1.0,5.8,3.2,0.30,0.60,16.8,78.5
T5_Biofert,0-15,2,7.42,6.82,0.33,0.69,0.073,352,22.2,181,20.2,1.01,5.85,3.22,0.302,0.61,16.9,79
T5_Biofert,0-15,3,7.41,6.81,0.325,0.685,0.0725,351,22.1,180.5,20.1,1.005,5.82,3.21,0.301,0.605,16.85,78.7
T6_Zero_till,0-15,1,7.3,6.7,0.35,0.72,0.075,360,20,175,19,1.08,6.0,3.3,0.32,0.62,17,79
T6_Zero_till,0-15,2,7.32,6.72,0.36,0.73,0.076,362,20.2,176,19.2,1.09,6.05,3.32,0.322,0.63,17.1,79.5
T6_Zero_till,0-15,3,7.31,6.71,0.355,0.725,0.0755,361,20.1,175.5,19.1,1.085,6.02,3.31,0.321,0.625,17.05,79.2
T1_Control,15-30,1,7.9,7.3,0.22,0.32,0.035,180,6,85,6,0.35,3.2,1.2,0.12,0.28,13,70
T2_NPK,15-30,1,7.6,7.0,0.30,0.42,0.045,260,14,140,14,0.65,4.5,2.2,0.20,0.42,15,75
T3_NPK_FYM,15-30,1,7.3,6.7,0.35,0.62,0.065,320,22,180,20,1.0,5.8,3.0,0.30,0.60,17,80
T4_Vermicompost,15-30,1,7.1,6.5,0.32,0.72,0.075,295,20,170,18,0.92,5.5,2.8,0.28,0.55,16.5,78
T5_Biofert,15-30,1,7.5,6.9,0.28,0.52,0.055,280,18,155,17,0.85,5.0,2.6,0.25,0.48,16,76
T6_Zero_till,15-30,1,7.4,6.8,0.30,0.58,0.060,295,16,150,16,0.90,5.2,2.7,0.27,0.50,16.2,77`,

  'soil-stcr': `Plot,Soil_N_kg_ha,Soil_P_kg_ha,Soil_K_kg_ha,Applied_N_kg_ha,Applied_P_kg_ha,Applied_K_kg_ha,Yield_t_ha,Crop_name
P01,210,8,95,0,0,0,2.5,Wheat
P02,215,9,98,50,20,20,3.5,Wheat
P03,218,10,100,75,25,25,4.2,Wheat
P04,220,11,102,100,30,30,4.8,Wheat
P05,222,12,105,125,40,40,5.3,Wheat
P06,225,13,108,150,50,50,5.7,Wheat
P07,230,14,110,175,60,60,5.9,Wheat
P08,235,15,115,200,70,70,5.85,Wheat
P09,240,16,120,50,30,25,3.8,Wheat
P10,245,17,125,75,40,35,4.5,Wheat
P11,250,18,130,100,50,45,5.0,Wheat
P12,255,19,132,125,60,55,5.4,Wheat
P13,260,20,135,150,70,65,5.8,Wheat
P14,265,22,140,100,30,30,4.9,Wheat
P15,270,24,142,100,40,40,5.1,Wheat
P16,275,26,145,100,50,50,5.3,Wheat
P17,280,28,148,100,60,60,5.4,Wheat
P18,200,6,85,0,0,0,2.2,Wheat
P19,205,7,88,50,20,20,3.2,Wheat
P20,208,8,92,75,25,25,3.9,Wheat
P21,212,9,95,100,30,30,4.5,Wheat
P22,218,10,98,125,35,35,5.0,Wheat
P23,225,12,102,150,45,45,5.5,Wheat
P24,232,14,108,175,55,55,5.8,Wheat
P25,240,16,115,150,60,60,5.85,Wheat`,

  'soil-health-index': `Plot_or_Treatment,Rep,Bulk_density,OC_percent,pH,Available_N,Available_P,Available_K,Microbial_biomass_C,Dehydrogenase_activity,Earthworm_count,Aggregate_stability,Infiltration_rate
T1_Control,1,1.55,0.42,8.2,220,8,95,180,55,12,48,5.2
T1_Control,2,1.57,0.43,8.22,222,8.2,96,182,56,13,49,5.25
T1_Control,3,1.56,0.425,8.21,221,8.1,95.5,181,55.5,12.5,48.5,5.22
T2_NPK,1,1.48,0.55,7.8,310,18,165,240,75,18,58,6.8
T2_NPK,2,1.50,0.56,7.82,312,18.2,166,242,76,19,59,6.85
T2_NPK,3,1.49,0.555,7.81,311,18.1,165.5,241,75.5,18.5,58.5,6.82
T3_NPK_FYM,1,1.35,0.85,7.2,410,28,210,385,115,48,75,9.5
T3_NPK_FYM,2,1.37,0.86,7.22,412,28.2,212,388,117,49,76,9.6
T3_NPK_FYM,3,1.36,0.855,7.21,411,28.1,211,386,116,48.5,75.5,9.55
T4_Vermicompost,1,1.38,0.92,7.0,385,25,195,420,125,55,78,10.2
T4_Vermicompost,2,1.40,0.93,7.02,387,25.2,196,422,127,56,79,10.25
T4_Vermicompost,3,1.39,0.925,7.01,386,25.1,195.5,421,126,55.5,78.5,10.22
T5_Organic,1,1.32,1.15,6.9,450,32,225,475,142,68,85,12.5
T5_Organic,2,1.34,1.16,6.92,452,32.2,226,478,144,69,86,12.55
T5_Organic,3,1.33,1.155,6.91,451,32.1,225.5,476,143,68.5,85.5,12.52
T6_Biofert,1,1.42,0.65,7.4,340,22,180,285,85,25,65,7.2
T6_Biofert,2,1.44,0.66,7.42,342,22.2,181,287,87,26,66,7.25
T6_Biofert,3,1.43,0.655,7.41,341,22.1,180.5,286,86,25.5,65.5,7.22
T7_Integrated,1,1.30,1.05,7.0,425,30,215,445,130,62,82,11.2
T7_Integrated,2,1.32,1.06,7.02,427,30.2,216,448,132,63,83,11.25
T7_Integrated,3,1.31,1.055,7.01,426,30.1,215.5,446,131,62.5,82.5,11.22
T8_Degraded,1,1.65,0.25,8.8,150,5,60,120,32,5,32,3.5
T8_Degraded,2,1.67,0.26,8.82,152,5.2,61,122,33,6,33,3.55
T8_Degraded,3,1.66,0.255,8.81,151,5.1,60.5,121,32.5,5.5,32.5,3.52`,

  'soil-nutrient-availability': `Treatment,Year,Rep,N_fertilizer_input,P_fertilizer_input,K_fertilizer_input,N_organic_input,P_organic_input,K_organic_input,N_atmospheric_deposition,N_biological_fixation,N_crop_removal,P_crop_removal,K_crop_removal,N_leaching_loss,N_volatilization_loss,yield
T1_NPK,2022,1,150,60,60,0,0,0,8,5,125,25,85,15,12,5.2
T1_NPK,2022,2,150,60,60,0,0,0,8,5,128,26,87,15.5,12.2,5.25
T1_NPK,2022,3,150,60,60,0,0,0,8,5,126,25.5,86,15.2,12.1,5.22
T2_NPK_FYM,2022,1,120,48,48,40,15,50,8,5,145,32,115,12,10,5.85
T2_NPK_FYM,2022,2,120,48,48,40,15,50,8,5,148,33,117,12.2,10.1,5.88
T2_NPK_FYM,2022,3,120,48,48,40,15,50,8,5,146,32.5,116,12.1,10.05,5.86
T3_100_FYM,2022,1,0,0,0,90,30,90,8,5,115,25,95,8,7,4.6
T3_100_FYM,2022,2,0,0,0,90,30,90,8,5,118,26,97,8.2,7.1,4.62
T3_100_FYM,2022,3,0,0,0,90,30,90,8,5,116,25.5,96,8.1,7.05,4.61
T4_Green_manure,2022,1,60,30,30,55,12,45,8,35,135,28,105,10,9,5.4
T4_Green_manure,2022,2,60,30,30,55,12,45,8,35,138,29,107,10.2,9.1,5.42
T4_Green_manure,2022,3,60,30,30,55,12,45,8,35,136,28.5,106,10.1,9.05,5.41
T5_Biofert,2022,1,120,48,48,0,0,0,8,15,130,26,90,13,10.5,5.3
T5_Biofert,2022,2,120,48,48,0,0,0,8,15,132,26.5,91,13.2,10.6,5.32
T5_Biofert,2022,3,120,48,48,0,0,0,8,15,131,26.2,90.5,13.1,10.55,5.31
T6_Control,2022,1,0,0,0,0,0,0,8,5,85,15,65,5,3,3.8
T6_Control,2022,2,0,0,0,0,0,0,8,5,88,16,67,5.2,3.1,3.82
T6_Control,2022,3,0,0,0,0,0,0,8,5,86,15.5,66,5.1,3.05,3.81
T1_NPK,2023,1,150,60,60,0,0,0,8,5,132,27,90,14,11.5,5.4
T2_NPK_FYM,2023,1,120,48,48,40,15,50,8,5,158,36,125,11,9.5,6.1
T3_100_FYM,2023,1,0,0,0,90,30,90,8,5,120,27,100,7.5,6.5,4.7
T4_Green_manure,2023,1,60,30,30,55,12,45,8,35,142,30,112,9.5,8.5,5.55
T5_Biofert,2023,1,120,48,48,0,0,0,8,15,138,28,95,12.5,10,5.45
T6_Control,2023,1,0,0,0,0,0,0,8,5,82,14,62,4.8,2.8,3.65`,

  'soil-microbial': `Treatment,Rep,Depth_cm,Microbial_biomass_C_ug_g,Microbial_biomass_N_ug_g,Dehydrogenase_ug_TPF_g_24hr,Urease_ug_NH4_g_hr,Phosphatase_ug_PNP_g_hr,Beta_glucosidase_ug_PNP_g_hr,Total_bacteria_CFU_g,Total_fungi_CFU_g,Actinomycetes_CFU_g,Azotobacter_CFU_g,PSB_CFU_g,Mycorrhizal_spore_count
T1_Control,1,0-15,185,32,58,22,85,42,3500000,45000,285000,12000,25000,28
T1_Control,2,0-15,188,33,60,23,87,43,3550000,46000,290000,12500,25500,29
T1_Control,3,0-15,186,32.5,59,22.5,86,42.5,3520000,45500,287000,12200,25200,28.5
T2_NPK,1,0-15,240,42,85,32,125,65,4800000,55000,385000,18000,35000,38
T2_NPK,2,0-15,243,43,87,33,127,66,4850000,56000,390000,18500,35500,39
T2_NPK,3,0-15,241,42.5,86,32.5,126,65.5,4820000,55500,387000,18200,35200,38.5
T3_NPK_FYM,1,0-15,385,68,135,52,215,112,7200000,95000,685000,32000,65000,62
T3_NPK_FYM,2,0-15,388,69,138,53,218,115,7250000,96000,690000,32500,65500,63
T3_NPK_FYM,3,0-15,386,68.5,136,52.5,216,113,7220000,95500,687000,32200,65200,62.5
T4_Vermicompost,1,0-15,420,75,148,58,235,125,7800000,105000,745000,38000,72000,68
T4_Vermicompost,2,0-15,423,76,150,59,238,127,7850000,106000,750000,38500,72500,69
T4_Vermicompost,3,0-15,421,75.5,149,58.5,236,126,7820000,105500,747000,38200,72200,68.5
T5_Organic,1,0-15,475,85,165,68,265,142,8500000,125000,825000,45000,85000,78
T5_Organic,2,0-15,478,86,168,69,268,145,8550000,126000,830000,45500,85500,79
T5_Organic,3,0-15,476,85.5,166,68.5,266,143,8520000,125500,827000,45200,85200,78.5
T6_Biofert,1,0-15,285,52,105,38,155,82,5500000,68000,485000,28000,55000,48
T6_Biofert,2,0-15,288,53,107,39,158,83,5550000,69000,490000,28500,55500,49
T6_Biofert,3,0-15,286,52.5,106,38.5,156,82.5,5520000,68500,487000,28200,55200,48.5
T7_Integrated,1,0-15,445,80,158,65,255,135,8200000,115000,785000,42000,80000,72
T7_Integrated,2,0-15,448,81,160,66,258,137,8250000,116000,790000,42500,80500,73
T7_Integrated,3,0-15,446,80.5,159,65.5,256,136,8220000,115500,787000,42200,80200,72.5
T1_Control,1,15-30,125,22,38,15,52,25,2200000,28000,180000,7500,15000,18
T2_NPK,1,15-30,165,28,55,22,82,42,3100000,35000,245000,12000,22500,25
T3_NPK_FYM,1,15-30,245,42,88,35,145,72,4800000,62000,435000,20500,42000,42`,

  'soil-carbon': `Treatment,Depth_cm,Rep,Year,Total_OC_percent,Active_C_mg_kg,Passive_C_mg_kg,Humic_acid_percent,Fulvic_acid_percent,Humin_percent,Bulk_density_g_cc,Soil_depth_m
T1_Control,0-15,1,2020,0.42,280,4120,18,12,45,1.55,0.15
T1_Control,0-15,2,2020,0.43,285,4150,18.2,12.1,45.2,1.56,0.15
T1_Control,0-15,3,2020,0.425,282,4135,18.1,12.05,45.1,1.555,0.15
T2_NPK,0-15,1,2020,0.55,385,5210,22,14,48,1.48,0.15
T2_NPK,0-15,2,2020,0.56,390,5250,22.2,14.1,48.2,1.49,0.15
T2_NPK,0-15,3,2020,0.555,387,5230,22.1,14.05,48.1,1.485,0.15
T3_NPK_FYM,0-15,1,2020,0.85,715,7185,28,18,52,1.35,0.15
T3_NPK_FYM,0-15,2,2020,0.86,720,7250,28.2,18.1,52.2,1.36,0.15
T3_NPK_FYM,0-15,3,2020,0.855,717,7215,28.1,18.05,52.1,1.355,0.15
T4_Organic,0-15,1,2020,1.15,985,9125,32,22,56,1.32,0.15
T4_Organic,0-15,2,2020,1.16,990,9200,32.2,22.1,56.2,1.33,0.15
T4_Organic,0-15,3,2020,1.155,987,9160,32.1,22.05,56.1,1.325,0.15
T1_Control,0-15,1,2023,0.38,250,4050,17,11.5,44,1.56,0.15
T2_NPK,0-15,1,2023,0.62,425,5550,23,15,49,1.46,0.15
T3_NPK_FYM,0-15,1,2023,1.05,875,7850,30,19,53,1.32,0.15
T4_Organic,0-15,1,2023,1.48,1250,9850,34,23,57,1.28,0.15`,

  'soil-quality-index': `Land_use_or_Treatment,Rep,Bulk_density,OC_percent,pH,Available_N,Available_P,Available_K,Microbial_biomass_C,Aggregate_stability,Infiltration_rate,Porosity_percent
Forest,1,1.25,1.85,6.8,485,32,245,465,82,12.5,52
Forest,2,1.27,1.87,6.82,487,32.5,247,468,83,12.7,52.5
Forest,3,1.26,1.86,6.81,486,32.2,246,466,82.5,12.6,52.2
Agriculture,1,1.48,0.65,7.4,295,18,155,240,58,6.8,44
Agriculture,2,1.50,0.66,7.42,297,18.2,156,242,59,6.85,44.5
Agriculture,3,1.49,0.655,7.41,296,18.1,155.5,241,58.5,6.82,44.2
Horticulture,1,1.35,1.25,7.1,405,28,205,385,72,9.8,49
Horticulture,2,1.37,1.27,7.12,407,28.2,207,388,73,9.85,49.5
Horticulture,3,1.36,1.26,7.11,406,28.1,206,386,72.5,9.82,49.2
Wasteland,1,1.65,0.25,8.5,145,5,65,120,32,3.2,38
Wasteland,2,1.67,0.26,8.52,147,5.2,66,122,33,3.25,38.5
Wasteland,3,1.66,0.255,8.51,146,5.1,65.5,121,32.5,3.22,38.2
Grassland,1,1.32,1.45,7.0,425,28,215,395,76,10.5,50
Grassland,2,1.34,1.47,7.02,427,28.2,217,398,77,10.55,50.5
Grassland,3,1.33,1.46,7.01,426,28.1,216,396,76.5,10.52,50.2
Wetland,1,1.22,2.25,6.5,525,38,270,515,85,14.5,54
Wetland,2,1.24,2.27,6.52,527,38.2,272,518,86,14.55,54.5
Wetland,3,1.23,2.26,6.51,526,38.1,271,516,85.5,14.52,54.2`,

  'soil-fertilizer-response': `Treatment,Fertilizer_dose_kg_ha,Yield_t_ha,Rep
N0,0,2.20,1
N0,0,2.25,2
N0,0,2.22,3
N50,50,3.45,1
N50,50,3.52,2
N50,50,3.48,3
N100,100,4.85,1
N100,100,4.92,2
N100,100,4.88,3
N150,150,5.65,1
N150,150,5.72,2
N150,150,5.68,3
N200,200,5.95,1
N200,200,6.02,2
N200,200,5.98,3
N250,250,5.85,1
N250,250,5.92,2
N250,250,5.88,3
N300,300,5.55,1
N300,300,5.62,2
N300,300,5.58,3`,

  'soil-land-use-change': `Land_use,Year,Rep,OC_percent,Bulk_density,pH,Available_N,Available_P,Available_K,Microbial_biomass_C
Forest,2020,1,1.85,1.25,6.8,485,32,245,465
Forest,2023,1,1.82,1.26,6.82,480,31,242,460
Agriculture,2020,1,0.65,1.48,7.4,295,18,155,240
Agriculture,2023,1,0.58,1.52,7.5,275,16,148,220
Horticulture,2020,1,1.25,1.35,7.1,405,28,205,385
Horticulture,2023,1,1.28,1.34,7.08,412,29,208,390
Wasteland,2020,1,0.25,1.65,8.5,145,5,65,120
Wasteland,2023,1,0.22,1.68,8.6,132,4.5,60,112
Grassland,2020,1,1.45,1.32,7.0,425,28,215,395
Grassland,2023,1,1.42,1.33,7.02,418,27.5,212,390`,
};

export const SOIL_SAMPLE_BANNERS = {
  'soil-physical': 'Sample loaded — 5 land uses × 2 depths × 3 reps (BD, texture, FC-PWP, HC, aggregate stability)',
  'soil-chemical': 'Sample loaded — 6 treatments × 2 depths × 3 reps with full ICAR nutrient panel',
  'soil-stcr': 'Sample loaded — 25-plot wheat STCR dataset (NPK × soil-test × yield)',
  'soil-health-index': 'Sample loaded — 8 land-use types × 3 reps with physical+chemical+biological indicators',
  'soil-nutrient-availability': 'Sample loaded — 6 INM treatments × 2 years × 3 reps rice-wheat system',
  'soil-microbial': 'Sample loaded — 7 treatments × 3 depths × 3 reps (MBC, enzymes, CFU counts)',
  'soil-carbon': 'Sample loaded — 4 treatments × 2 years × 3 reps Indo-Gangetic soil (active/passive C + humic fractions)',
  'soil-quality-index': 'Sample loaded — 6 land uses × 3 reps (forest/agriculture/horticulture/wasteland/grassland/wetland)',
  'soil-fertilizer-response': 'Sample loaded — 7 N doses × 3 reps (quadratic yield response for economic optimum)',
  'soil-land-use-change': 'Sample loaded — 5 land uses × 2 years (temporal soil-indicator change analysis)',
};
